import { render } from "./ContactsPanel.vue?vue&type=template&id=2b0afade"
import script from "./ContactsPanel.vue?vue&type=script&lang=js"
export * from "./ContactsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__